import { SlotRepository } from '../Repositories/SlotRepository';

export class CheckSlotExistsUseCase {
  constructor(private repo: SlotRepository) {}

  execute(ids: number[]) {
    return this.repo.checkExists(ids);
  }
}
